import { Button, Col, Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BackButton from "../BackButton";

function AdminDetailServices() {

    const navigate = useNavigate();

    return (
        <>
            <div className="d-flex justify-content-center" style={{ marginTop: '30px' }}>
                <Container>
                    <Col>
                        <Button variant="warning" className="indent-button" onClick={() => (navigate('/totalOrdersList'))}>View All Orders</Button>
                        <Button variant="info" className="indent-button" onClick={() => (navigate('/allAgentsList'))}>View All Agents</Button>
                        <Button variant="success" className="indent-button" onClick={() => (navigate('/allCustomersList'))}>View All Customers</Button>
                        <Button variant="danger" className="indent-button" onClick={() => (navigate('/businessConfigManager'))}>Business Configeration</Button>
                    </Col>
                </Container>
            </div>
            <div className="indent-container">
                <BackButton />
            </div>
        </>
    );

}

export default AdminDetailServices;